export const opportunityTrackingColumns = [
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'active',
  'day',
  'join_id',
  'log',
  'natural_key',
  'rule_detail_id',
  'rule_detail_version',
  'type',
];
